import React, { useState, useRef } from "react";
import { Container, Row, Col, Button, Form } from "react-bootstrap";
import "../../../App.css";
import "../../../css/bootstrap.scss";
import doc_icon from "../../../images/upload_doc_icon.png";
import red_cross_icon from "../../../images/circle_cross.png";
import identity_card_banner from "../../../images/identity_card_banner.png";
import QRCode from "react-qr-code";
import BackButton from "../../Includes/BackButton";
import CameraModal from "../../Camera/CameraModal";
import SelfieCameraModal from "../../Camera/SelfieCameraModal";
import { reduxForm, InjectedFormProps } from "redux-form";
import { connect } from "react-redux";
import {
  setidentityCardBackendPic,
  setidentityCardFrontendPic,
  setwizardPageNumber,
} from "../../authslice";
import { RootState } from "../../store";
import { useDispatch, useSelector } from "react-redux";
import { ToastBox } from "MyComponents/Toaster";
import Spacer from "MyComponents/UI/Spacer";
import { updatePersonalKycDraftStep } from "Utils/personalKycDraft";
import { useTranslation } from "react-i18next";

interface Props {}

const UploadIdentityCard: React.FC<
  Props & InjectedFormProps<{}, Props, FormData>
> = (props: any) => {
  const { t } = useTranslation();
  const { handleSubmit } = props;
  const dispatch = useDispatch();

  const BaseURL = process.env.REACT_APP_BASE_URL;

  const userId = useSelector((state: RootState) => state.auth.userID);
  const kycToken = useSelector((state: RootState) => state.auth.kycToken);
  const page = useSelector((state: RootState) => state.auth.wizardPageNumber);
  const theme = useSelector((state: RootState) => state.theme.theme);

  const [showModal1, setShowModal1] = useState(false);
  const [showModal2, setShowModal2] = useState(false);

  const modalRef1 = useRef<string | null>(null);
  const modalRef2 = useRef<string | null>(null);

  const identityCardFrontendPic = useSelector((state: RootState) => state.auth.identityCardFrontendPic);
  const identityCardBackendPic = useSelector((state: RootState) => state.auth.identityCardBackendPic);

  const [srcModal1, setSrcModal1] = useState<string | null>(
    identityCardFrontendPic && identityCardFrontendPic.startsWith("data:image") ? identityCardFrontendPic : null
  );
  const [srcModal2, setSrcModal2] = useState<string | null>(
    identityCardBackendPic && identityCardBackendPic.startsWith("data:image") ? identityCardBackendPic : null
  );
  const [validated, setValidated] = useState(false);

  const updateSrcModal1 = (newState: string) => {
    dispatch(setidentityCardFrontendPic(newState));
    setSrcModal1(newState);
    setValidated(false);
  };

  const updateSrcModal2 = (newState: string) => {
    dispatch(setidentityCardBackendPic(newState));
    setSrcModal2(newState);
  };

  const handleCloseModal1 = () => setShowModal1(false);
  const handleCloseModal2 = () => setShowModal2(false);

  const handleModal1CrossIconClick = () => {
    setSrcModal1(null);
    dispatch(setidentityCardFrontendPic(""));
  };

  const handleModal2CrossIconClick = () => {
    setSrcModal2(null);
  };

  const submitForm = () => {
    if (!srcModal1) {
      setValidated(true);
      return;
    }
    dispatch(setwizardPageNumber(page + 1));
    localStorage.setItem("pageNumber", `${page + 1}`);
  };

  const saveExit = () => {
    if (!srcModal1) {
      setValidated(true);
      return;
    }
    dispatch(setwizardPageNumber(page + 1));
    localStorage.setItem("pageNumber", `${page + 1}`);

    if (userId) {
      updatePersonalKycDraftStep(userId, "idVerification", {
        identityCardFrontendPic: srcModal1,
        identityCardBackendPic: srcModal2,
      });
      updatePersonalKycDraftStep(userId, "wizardState", {
        pageNumber: page + 1,
      });
    }
  };

  return (
    <>
      <ToastBox />

      <CameraModal
        show={showModal1}
        handleClose={handleCloseModal1}
        title="Identity Card"
        ref={modalRef1}
        side="Front side of"
        updateSrc={updateSrcModal1}
      />

      <SelfieCameraModal
        show={showModal2}
        handleClose={handleCloseModal2}
        title="Identity Card"
        ref={modalRef2}
        side="Back side of"
        updateSrc={updateSrcModal2}
      />

      <Container fluid>
        <Row>
          <Col md={12}>
            <div className="mt-5">
              <Row className="px-2 px-md-5">
                <Col md={12}>
                  <Spacer height="30px" />
                  <BackButton />
                </Col>
              </Row>

              <Row className="px-2 px-md-5">
                <Col md={12}>
                  <div className="d-flex align-items-start py-3">
                    <img src={doc_icon} width={48} className="me-3 mt-1" alt="doc icon" />
                    <div>
                      <h3 className="text-start m-0">{t('kyc.upload_identity_card')}</h3>
                      <p className="fw-normal text-secondary m-0 mt-1">{t('kyc.confirm_secure')}</p>
                    </div>
                  </div>
                </Col>
              </Row>

              <Form noValidate onSubmit={handleSubmit(submitForm)}>
                <Row className="px-2 px-md-5">
                  <Col md={12} className="rounded-3">
                    <Row className="p-2 p-md-4">

                      <Col xs={12} md={4}>
                        <p className="fw-bold small mb-2">{t('kyc.front_identity_card')}</p>
                        <div
                          onClick={() => setShowModal1(true)}
                          className="text-center position-relative d-flex flex-column justify-content-center align-items-center"
                          style={{
                            border: `2px dashed ${validated && !srcModal1 ? "#dc3545" : "#C9DAF8"}`,
                            borderRadius: "12px",
                            height: "140px",
                            background: theme === "dark" ? "#1a1a1a" : "#EDF7F3",
                            cursor: "pointer",
                          }}
                        >
                          {srcModal1 ? (
                            <>
                              <img
                                src={red_cross_icon}
                                onClick={(e) => {
                                  e.stopPropagation();
                                  handleModal1CrossIconClick();
                                }}
                                style={{
                                  position: "absolute",
                                  top: "6px",
                                  right: "6px",
                                  width: "20px",
                                  cursor: "pointer",
                                }}
                                alt="remove"
                              />
                              <img
                                src={srcModal1}
                                alt="Front Identity Card"
                                className="img-fluid rounded-3 object-fit-cover w-100 h-100"
                              />
                            </>
                          ) : (
                            <>
                              <i className="fa-solid fa-camera" style={{ fontSize: '32px', color: '#00D084' }} />
                              <p className="small mt-2 text-secondary">{t('camera.take_photo')}</p>
                            </>
                          )}
                        </div>
                        {validated && !srcModal1 && (
                          <div className="text-danger small mt-1 fw-bold">
                            {t('kyc.front_side_missing')}
                          </div>
                        )}

                        <p className="fw-bold small mt-3 mb-2">{t('kyc.back_identity_card')}</p>
                        <div
                          onClick={() => setShowModal2(true)}
                          className="text-center position-relative d-flex flex-column justify-content-center align-items-center"
                          style={{
                            border: "2px dashed #C9DAF8",
                            borderRadius: "12px",
                            height: "140px",
                            background: theme === "dark" ? "#1a1a1a" : "#EDF7F3",
                            cursor: "pointer",
                          }}
                        >
                          {srcModal2 ? (
                            <>
                              <img
                                src={red_cross_icon}
                                onClick={(e) => {
                                  e.stopPropagation();
                                  handleModal2CrossIconClick();
                                }}
                                style={{
                                  position: "absolute",
                                  top: "6px",
                                  right: "6px",
                                  width: "20px",
                                  cursor: "pointer",
                                }}
                                alt="remove"
                              />
                              <img
                                src={srcModal2}
                                alt="Back Identity Card"
                                className="img-fluid rounded-3 object-fit-cover w-100 h-100"
                              />
                            </>
                          ) : (
                            <>
                              <i className="fa-solid fa-camera" style={{ fontSize: '32px', color: '#00D084' }} />
                              <p className="small mt-2 text-secondary">{t('camera.take_photo')}</p>
                            </>
                          )}
                        </div>
                      </Col>

                      <Col md={4} className="d-none d-md-block">
                        <p className="fw-bold ms-2 mb-1">{t('kyc.qr_code')}</p>
                        <Row className={`ms-2 justify-content-center rounded-3 mt-3 ${theme === "light" && "bg-sky"}`}>
                          <div style={{ width: 256, margin: "20px auto 0" }}>
                            <QRCode
                              value={`${BaseURL}/kyc/personal/${userId}/${kycToken}`}
                              size={256}
                              style={{ width: "100%", height: "auto" }}
                            />
                          </div>
                          <p className="fw-bold text-center mt-2">{t('kyc.qr_scan_title')}</p>
                          <p className="text-secondary small text-center mb-5">{t('kyc.qr_scan_desc')}</p>
                        </Row>
                      </Col>

                      <Col md={4} className="mt-4 d-none d-md-block">
                        <Row className={`justify-content-center rounded-3 mt-3 ms-2 ${theme === "light" && "bg-sky"}`}>
                          <div className="text-center">
                            <img
                              className="mt-3 py-3"
                              src={identity_card_banner}
                              width={153}
                              height={125}
                              alt="Identity card banner"
                            />
                          </div>
                          <Row className="px-4 mb-2">
                            <p className="fw-bold small">{t('kyc.doc_standards_title')}</p>
                            <ul className="list-group border-0 bg-transparent fw-normal">
                              <li className="list-group-item border-0 bg-transparent text-secondary p-0 small">{t('kyc.doc_clear')}</li>
                              <li className="list-group-item border-0 bg-transparent text-secondary p-0 small">{t('kyc.doc_not_reflective')}</li>
                              <li className="list-group-item border-0 bg-transparent text-secondary p-0 small">{t('kyc.doc_no_edit')}</li>
                              <li className="list-group-item border-0 bg-transparent text-secondary p-0 small">{t('kyc.doc_solid_bg')}</li>
                            </ul>
                          </Row>
                        </Row>
                      </Col>

                      <Col md={12} className="d-flex justify-content-end mt-4">
                        <Button className="btn btn-primary rounded-5" onClick={saveExit}>
                          {t('common.save')}
                        </Button>
                      </Col>

                    </Row>
                  </Col>
                </Row>
              </Form>
            </div>
          </Col>
        </Row>
      </Container>
    </>
  );
};

const form = reduxForm<{}, Props, FormData>({
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true,
  form: "wizard",
  enableReinitialize: true,
})(UploadIdentityCard);

export default connect(null)(form);
